var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmexEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 60,
    viewBox: "0 0 96 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 95.5,
    height: 59.5,
    rx: 3.75,
    stroke: "#0077C8",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.4517 30.3062H54.5591H55.6704V26.1681V22H54.5606H53.4517V26.1531V30.3062Z",
    fill: "#016FD0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0623 25.5597H46.7365V23.8872H49.0623C49.7275 23.8872 50.059 24.2786 50.059 24.7291C50.059 25.1795 49.7275 25.5597 49.0623 25.5597ZM52.2904 24.6819C52.2904 23.0918 51.1508 22 49.3242 22H44.5186V30.3062H46.7373V27.3998H47.5439L50.0717 30.3062H52.8247L50.0717 27.304C51.4598 27.0069 52.2904 25.987 52.2904 24.6819Z",
    fill: "#016FD0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0647 26.2242V26.07C59.0647 24.8361 59.7524 23.9456 61.1764 23.9456H63.6443V22H60.9863C58.246 22 56.8452 23.7555 56.8452 26.07V26.2361C56.8452 28.8103 58.4346 30.3062 60.8793 30.3062H61.6388L62.5293 28.4189H61.2235C59.8953 28.4189 59.0647 27.6714 59.0647 26.2242Z",
    fill: "#016FD0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9039 26.7936L18.0675 24.0174L19.2296 26.7936H16.9039ZM16.6667 22L13 30.3062H15.4447L16.1451 28.621H19.9892L20.7015 30.3062H23.2046L19.5379 22H16.6659H16.6667Z",
    fill: "#016FD0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0072 27.2329L27.1095 22H23.6201V30.3062H25.8044V24.325L27.9992 30.3062H29.9687L32.1635 24.325V30.3062H34.3471V22H30.8944L29.0072 27.2329Z",
    fill: "#016FD0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0432 30.3062H43.0683V28.4189H38.2619V27.0907H42.9493V25.2035H38.2619V23.8865H43.0683V22H36.0432V30.3062Z",
    fill: "#016FD0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5768 26.7936L67.7404 24.0174L68.9025 26.7936H66.5768ZM66.3395 22L62.6729 30.3062H65.1176L65.818 28.621H69.662L70.3744 30.3062H72.8775L69.2108 22H66.3388H66.3395Z",
    fill: "#016FD0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4747 27.0668L76.0924 22H73.293V30.3062H75.499V25.0493L78.9876 30.3062H81.6695V22H79.4747V27.0668Z",
    fill: "#016FD0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1712 35.891H70.1299C69.6906 35.891 69.3703 35.6299 69.3703 35.2265C69.3703 34.8232 69.6906 34.5733 70.1299 34.5733H73.8197L74.6863 32.686H70.1179C68.2314 32.686 67.1516 33.8018 67.1516 35.2969C67.1516 36.792 68.1955 37.7775 69.8223 37.7775H71.8637C72.3142 37.7775 72.6225 38.0387 72.6225 38.442C72.6225 38.8453 72.3142 39.1065 71.8637 39.1065H67.4128V40.9937H71.8749C73.7382 40.9937 74.8412 39.9012 74.8412 38.2998C74.8412 36.7815 73.8691 35.891 72.172 35.891",
    fill: "#016FD0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.802 36.2469H52.4763V34.5745H54.802C55.4665 34.5745 55.7987 34.9658 55.7987 35.4163C55.7987 35.8668 55.4665 36.2469 54.802 36.2469ZM58.0302 35.3692C58.0302 33.779 56.8905 32.6873 55.0639 32.6873H50.2583V40.9934H52.477V38.087H53.2837L55.8115 40.9934H58.5645L55.8115 37.9912C57.1996 37.6942 58.0302 36.6742 58.0302 35.3692Z",
    fill: "#016FD0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1951 40.9934H66.2201V39.1062H61.4138V37.778H66.1019V35.8907H61.4138V34.5745H66.2201V32.6873H59.1951V40.9934Z",
    fill: "#016FD0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0813 36.4011H43.6965V34.5745H46.0813C46.7458 34.5745 47.0781 34.989 47.0781 35.4994C47.0781 36.0097 46.7458 36.4011 46.0813 36.4011ZM46.3425 32.6873H41.4778V40.9934H43.6965V38.2883H46.2714C48.1459 38.2883 49.3088 37.1015 49.3088 35.4882C49.3088 33.8748 48.1699 32.6873 46.3425 32.6873Z",
    fill: "#016FD0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3304 35.891H78.289C77.8498 35.891 77.5295 35.6299 77.5295 35.2265C77.5295 34.8232 77.8498 34.5733 78.289 34.5733H81.9789L82.8455 32.686H78.2771C76.3906 32.686 75.3108 33.8018 75.3108 35.2969C75.3108 36.792 76.3547 37.7775 77.9815 37.7775H80.0229C80.4733 37.7775 80.7816 38.0387 80.7816 38.442C80.7816 38.8453 80.4733 39.1065 80.0229 39.1065H75.5719V40.9937H80.0341C81.8974 40.9937 83.0004 39.9012 83.0004 38.2998C83.0004 36.7815 82.0283 35.891 80.3312 35.891",
    fill: "#016FD0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6201 40.9934H30.6452V39.1062H25.8388V37.778H30.527V35.8907H25.8388V34.5745H30.6452V32.6873H23.6201V40.9934Z",
    fill: "#016FD0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0735 32.6873H38.2494L36.0905 35.1911L33.9301 32.6873H31.035L34.6897 36.7924L30.9639 40.9934H33.788L36.0538 38.3587L38.3212 40.9934H41.2164L37.4659 36.7453L41.0735 32.6873Z",
    fill: "#016FD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexEnabled);
export default __webpack_public_path__ + "static/media/AmexEnabled.39ffc60c4d396192845c88b8b4f3065d.svg";
export { ForwardRef as ReactComponent };